module.exports = __webpack_public_path__ + "static/media/kotatsu_squire.bb186110.png";